export default __webpack_public_path__ + "static/media/Background_00037.daf65d38.png";